import {ScaleDot} from './ScaleDot';

declare let THREE: any;

export class Scaler extends (THREE.Object3D as { new(): any; }) {

  private static directions = [
    [
      new THREE.Vector3(-1, 0, 0),
      new THREE.Vector3(0, 0, -1)
    ],
    [
      new THREE.Vector3(-1, 0, 0),
      new THREE.Vector3(0, 0, 1)
    ],
    [
      new THREE.Vector3(1, 0, 0),
      new THREE.Vector3(0, 0, -1)
    ],
    [
      new THREE.Vector3(1, 0, 0),
      new THREE.Vector3(0, 0, 1)
    ],
    [
      new THREE.Vector3(0, 0, -1)
    ],
    [
      new THREE.Vector3(0, 0, 1)
    ],
    [
      new THREE.Vector3(-1, 0, 0)
    ],
    [
      new THREE.Vector3(1, 0, 0),
    ]
  ];

  private dotSize = 8;
  private dotSizeOffset = new THREE.Vector3(this.dotSize / 2, 0, this.dotSize / 2);
  private dotExtraOffset = new THREE.Vector3(3, 0, 3);

  constructor() {
    super();
    const dots = Scaler.directions
      .map(directions => new ScaleDot(directions.map(d => d.clone()), this.dotSize));
    this.add(...dots);
    this.name = 'scaler';
    this.visible = false;
  }

  getDots(): Array<ScaleDot> {
    return this.children.filter(ch => ch instanceof ScaleDot);
  }

  update() {
    const selection = this.parent.selection;
    const offset = selection.scale
      .clone()
      .divideScalar(2)
      .add(this.dotSizeOffset)
      .add(this.dotExtraOffset)
      .setY(0);
    this.position.copy(selection.position);
    this.getDots()
      .forEach(dot => dot.position.copy(dot.direction.multiply(offset)));
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Scaler.ts